import {createSlice} from "@reduxjs/toolkit";

const initialAddContestUserState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
  createUser: {},
  uploadimage: [], 
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const AddContestUserFormSlice = createSlice({
  
  name: "addContestUserForm",
  initialState: initialAddContestUserState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    uploadImage: (state, action) => {
      const { uploadimage, imageField} = action.payload;
      state.error = null;
      state.uploadimage = uploadimage;
      state.imageField = imageField;
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    createUser: (state, action) => {
      const { createUser } = action.payload;
      state.error = null;
      state.createUser = createUser;
    },
  }
});
